// material-ui
import type { CSSObject } from '@mui/material/styles'
// project import
import type { ColorProps } from 'types/extended'

import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import getColors from 'utils/getColors'

interface Props {
  color?: ColorProps
  size?: number
  variant?: string
  sx?: CSSObject
}

function Dot({ color, size, variant, sx }: Props) {
  const theme = useTheme()
  const colors = getColors(theme, color || 'primary')
  const { main } = colors

  return (
    <Box
      component="span"
      sx={{
        width: size || 8,
        height: size || 8,
        borderRadius: '50%',
        bgcolor: variant === 'outlined' ? '' : main,
        ...(variant === 'outlined' && {
          border: `1px solid ${main}`,
        }),
        ...sx,
      }}
    />
  )
}

export default Dot
